import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

export const TextItemSchema = buildEntrySchemaFor('textItem', {
  fields: z.lazy(() =>
    z.object({
      title: z.string().optional(),
      heading: RichTextSchema,
      description: RichTextSchema,
    }),
  ),
})
export type TextItem = z.infer<typeof TextItemSchema>
